import createAction from '../../common/services/create-action';

export const CATEGORY_ADD_GROUP = 'category/ADD_GROUP';
export const CATEGORY_REMOVE_GROUP = 'category/REMOVE_GROUP';

export const categoryAddGroups = createAction(CATEGORY_ADD_GROUP);
export const categoryRemoveGroups = createAction(CATEGORY_REMOVE_GROUP);
